import { render, staticRenderFns } from "./MbOverlayStage.vue?vue&type=template&id=3fd2c299"
import script from "./MbOverlayStage.vue?vue&type=script&lang=js"
export * from "./MbOverlayStage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports